export const editProjectFieldSx = {
  '& .MuiInputLabel-root.MuiInputLabel-shrink': {
    bgcolor: 'background.paper',
    px: 0.5,
    borderRadius: 0.5,
  },
} as const

export const editProjectSelectFieldSx = {
  ...editProjectFieldSx,
  '& .MuiOutlinedInput-root': {
    minHeight: 40,
  },
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    minHeight: '40px !important',
    py: 0,
  },
} as const
